import React, {useState} from 'react';
import clsx from "clsx";
import {motion} from "framer-motion";
import Button from "../../elements/Button/Button";
import styles from "../../FormController/components/Form/Form.module.scss";
import loginStyles from './Login.module.scss'
import {useNavigate} from "react-router-dom";
import {loginSuccess, logUser} from "../../../store/actions/authActions";
import {useDispatch, useSelector} from "react-redux";
import {loginRequest} from "../../../services/auth";
import toast from "react-hot-toast";
import formValidation from "../../../utilities/formValidation";
import {setErrors} from "../../../store/actions/errorsActions";

const Login = () => {
    document.title = 'Login | Invoice App';
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loginErrors = useSelector((state) => state.errors.login);
    const [credentials, setCredentials] = useState({ email: '', password: '' });

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setCredentials((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleForgotPassword = () => {
        // navigate('/forgot-password');
        toast.error('This feature is not available yet.');
    }

    const handleLogin = async (event) => {
        event.preventDefault();
        const validationErrors = formValidation(credentials);
        if (validationErrors.length > 0) {
            dispatch(setErrors('login', {}, validationErrors));
            return;
        }

        dispatch(logUser());

        try {
            const response = await loginRequest(credentials);
            console.log(response);
            if (response.status === 200) {
                dispatch(loginSuccess(response));
                console.log(response);
                sessionStorage.setItem('authTokenData', JSON.stringify(response.data.access_token));
                navigate('/');
            }
        } catch (error) {
            if (error.response.status === 429) {
                dispatch(setErrors('login', error.response.data.errors || {}, [error.response.data.message || 'Too many requests. Please wait a while before trying again.']));
                toast.error(error.response.data.message || 'Too many requests. Please wait a while before trying again.');
            } else if (error.response.status === 400) {
                dispatch(setErrors('login', error.response.data.errors || {}, [error.response.data.message || 'Account is disabled.']));
                toast.error(error.response.data.message || 'Account is disabled. Please, contact support.');
            } else {
                dispatch(setErrors('login', error.response.data.errors || {}, [error.response.data.message || 'Login failed. Please try again.']));
                toast.error(error.response.data.message || 'Login failed. Please try again.');
            }
        }
    };

    return (
        <motion.div className={loginStyles.loginBg}>
            <motion.div
                className={loginStyles.shape1}
                animate={{
                    scale: [1, 1.15, 1],
                    rotate: [0, 360],
                }}
                transition={{
                    duration: 10,
                    repeat: Infinity,
                    ease: "linear",
                }}
            />
            <motion.div
                className={loginStyles.shape2}
                animate={{
                    scale: [1, 1.15, 1],
                    rotate: [0, -360],
                }}
                transition={{
                    duration: 10,
                    repeat: Infinity,
                    ease: "linear",
                }}
            />
            <motion.div
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                transition={{
                    duration: 1,
                    ease: "easeOut",
                    bounce: 0.3,
                }}
                className={loginStyles.formContainer}>
                <h2 className={styles.title}>
                    Welcome! Please, login.
                </h2>
                <form onSubmit={handleLogin}>
                    <div className={loginStyles.inputGroup}>
                        <div className={styles.inputContainer}>
                            <label
                                htmlFor="email"
                                className={clsx(styles.label, {
                                    [styles.error]: loginErrors.email,
                                })}
                            >
                                Email
                                {loginErrors.email && (
                                    <span className={styles.error}>Can't be empty</span>
                                )}
                            </label>
                            <input
                                className={clsx(styles.input, {
                                    [styles.error]: loginErrors.email
                                })}
                                type="text"
                                name="email"
                                value={credentials.email}
                                placeholder="manager@gamrise.com"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className={styles.inputContainer}>
                            <label
                                className={clsx(styles.label, {
                                    [styles.error]: loginErrors.password,
                                })}
                                htmlFor="password"
                            >
                                Password
                                {loginErrors.password && (
                                    <span className={styles.error}>Can't be empty</span>
                                )}
                            </label>
                            <input
                                className={clsx(styles.input, {
                                    [styles.error]: loginErrors.password,
                                })}
                                type="password"
                                name="password"
                                value={credentials.password}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className={loginStyles.buttonContainer}>
                        <Button className='primary' type="submit">Login</Button>
                    </div>
                    <div className={loginStyles.otherButtons}>
                        <Button
                            onClick={handleForgotPassword}
                            className={clsx('tertiary', 'small')}
                            type="button"
                        >
                            Forgot password?
                        </Button>
                    </div>
                </form>
                {loginErrors.msg.length > 0 && (
                    <div className={loginStyles.errorContainer}>
                        {loginErrors.msg.map((item, index) => (
                            <span key={index} className={styles.error}>{item}</span>
                        ))}
                    </div>
                )}
            </motion.div>
        </motion.div>
    );
};

export default Login;
